import { render, staticRenderFns } from "./SupplierAnalysis.vue?vue&type=template&id=6f6976c9"
import script from "./SupplierAnalysis.vue?vue&type=script&lang=ts"
export * from "./SupplierAnalysis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports